export default "__VITE_ASSET__3499d892__"